export default {
    MEAL_REGISTRATION_FETCH: 'MEAL_REGISTRATION_FETCH',
    MEAL_REGISTRATION_FETCH_SUCCESS: 'MEAL_REGISTRATION_FETCH_SUCCESS',
    MEAL_REGISTRATION_FETCH_FAILED: 'MEAL_REGISTRATION_FETCH_FAILED',
    MEAL_REGISTRATIONS_CREATE: 'MEAL_REGISTRATIONS_CREATE',
    MEAL_REGISTRATIONS_CREATE_SUCCESS: 'MEAL_REGISTRATIONS_CREATE_SUCCESS',
    MEAL_REGISTRATIONS_CREATE_FAILED: 'MEAL_REGISTRATIONS_CREATE_FAILED',
    MEAL_REGISTRATION_UPDATE: 'MEAL_REGISTRATION_UPDATE',
    MEAL_REGISTRATION_UPDATE_SUCCESS: 'MEAL_REGISTRATION_UPDATE_SUCCESS',
    MEAL_REGISTRATION_UPDATE_FAILED: 'MEAL_REGISTRATION_UPDATE_FAILED',
    MEAL_REGISTRATION_DELETE: 'MEAL_REGISTRATION_DELETE',
    MEAL_REGISTRATION_DELETE_SUCCESS: 'MEAL_REGISTRATION_DELETE_SUCCESS',
    MEAL_REGISTRATION_DELETE_ABORTED: 'MEAL_REGISTRATION_DELETE_ABORTED',
    MEAL_REGISTRATION_DELETE_FAILED: 'MEAL_REGISTRATION_DELETE_FAILED',
};
